import { setTrackView, setTrackWithNewDatalayer, useTracking } from '@vfit/shared/data-access';
import { setTrackLink } from '@vfit/shared/data-access';
import { withAnimationDelay } from '../../hoc/withAnimationDelay';
import { getEnergyTagging, getUserInfo } from '../../checkoutEnergy.utils';
import { useEnergyCheckout } from '../../../energy.context';

const TaggingComponent = () => {
  const { product } = useEnergyCheckout();
  const taggingEnergy = getEnergyTagging(product, 'personal data');

  const { trackView, trackWithNewDatalayer } = useTracking({
    event: ['checkout_step1'],
    event_label: 'personal information',
    opts: taggingEnergy?.opts,
    cartProduct: taggingEnergy?.trackingProduct,
    pageProduct: taggingEnergy?.pageProductsInfo,
    visitorTrackingOpts: getUserInfo(),
  });
  setTrackLink(trackView, 'personal information');
  setTrackView(trackView);
  setTrackWithNewDatalayer(trackWithNewDatalayer);

  return null;
};

const TaggingNameFiscalCodeCard = withAnimationDelay()(TaggingComponent);

export default TaggingNameFiscalCodeCard;
